const wetlandPark = [
  {
    id: 1,
    name: "重庆巴山湖国家湿地公园",
    img: "http://h5cloud.cqliving.com/image/sd61/1重庆巴山湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆巴山湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆巴山湖国家湿地公园@2x.png")
  },
  {
    id: 2,
    name: "重庆迎风湖国家湿地公园",
    img: "http://h5cloud.cqliving.com/image/sd61/2重庆迎风湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆迎风湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆迎风湖国家湿地公园@2x.png")
  },
  {
    id: 3,
    name: "重庆彩云湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/3 重庆九龙坡彩云湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆九龙坡彩云湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆九龙坡彩云湖国家湿地公园@2x.png")
  },
  {
    id: 4,
    name: "重庆开州汉丰湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/4重庆开州汉丰湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆开州汉丰湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆开州汉丰湖国家湿地公园@2x.png")
  },
  {
    id: 5,
    name: "重庆迎龙湖国家湿地公园",
    img: "http://h5cloud.cqliving.com/image/sd61/5重庆迎龙湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆迎龙湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆迎龙湖国家湿地公园@2x.png")
  },
  {
    id: 6,
    name: "重庆南川黎香湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/6重庆南川黎香湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆南川黎香湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆南川黎香湖国家湿地公园@2x.png")
  },
  {
    id: 7,
    name: "重庆綦江通惠河国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/7重庆綦江通惠河国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆南川黎香湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆南川黎香湖国家湿地公园@2x.png")
  },
  {
    id: 8,
    name: "重庆濑溪河国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/8荣昌-重庆濑溪河国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/荣昌-重庆濑溪河国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/荣昌-重庆濑溪河国家湿地公园@2x.png")
  },
  {
    id: 9,
    name: "重庆石柱藤子沟国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/9重庆石柱藤子沟国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆石柱藤子沟国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆石柱藤子沟国家湿地公园@2x.png")
  },
  {
    id: 10,
    name: "重庆铜梁安居国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/10重庆铜梁安居国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆铜梁安居国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆铜梁安居国家湿地公园@2x.png")
  },
  {
    id: 11,
    name: "重庆青山湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/11万盛 重庆青山湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/万盛-重庆青山湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/万盛-重庆青山湖国家湿地公园@2x.png")
  },
  {
    id: 12,
    name: "重庆秀山大溪国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/12秀山重庆秀山大溪国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/秀山重庆秀山大溪国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/秀山重庆秀山大溪国家湿地公园@2x.png")
  },
  {
    id: 13,
    name: "重庆酉水河国家湿地公园",
    img: "http://h5cloud.cqliving.com/image/sd61/13 重庆酉水河国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆酉水河国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆酉水河国家湿地公园@2x.png")
  },
  {
    id: 14,
    name: "重庆合川三江国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/14重庆合川三江国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆合川三江国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆合川三江国家湿地公园@2x.png")
  },
  {
    id: 15,
    name: "重庆皇华岛国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/15忠县重庆皇华岛国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/忠县重庆皇华岛国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/忠县重庆皇华岛国家湿地公园@2x.png")
  },
  {
    id: 16,
    name: "重庆大昌湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/16重庆巫山大昌湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆巫山大昌湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆巫山大昌湖国家湿地公园@2x.png")
  },
  {
    id: 17,
    name: "重庆武隆芙蓉湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/17重庆武隆芙蓉湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆武隆芙蓉湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆武隆芙蓉湖国家湿地公园@2x.png")
  },
  {
    id: 18,
    name: "重庆秀湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/18重庆璧山秀湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆璧山秀湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆璧山秀湖国家湿地公园@2x.png")
  },
  {
    id: 19,
    name: "重庆梁平双桂湖国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/19重庆梁平双桂湖国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/重庆梁平双桂湖国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/重庆梁平双桂湖国家湿地公园@2x.png")
  },
  {
    id: 20,
    name: "重庆龙河国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/20丰都-重庆龙河国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/丰都-重庆龙河国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/丰都-重庆龙河国家湿地公园@2x.png")
  },
  {
    id: 21,
    name: "重庆阿蓬江国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/21黔江重庆阿蓬江国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/黔江重庆阿蓬江国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/黔江重庆阿蓬江国家湿地公园@2x.png")
  },
  {
    id: 22,
    name: "重庆涪江国家湿地公园",
    img:
      "http://h5cloud.cqliving.com/image/sd61/22潼南重庆涪江国家湿地公园.jpg",
    text1img: require("../assets/images/cultivation/text1/潼南重庆涪江国家湿地公园@2x.png"),
    text2img: require("../assets/images/cultivation/text2/潼南重庆涪江国家湿地公园@2x.png")
  }
];
export default wetlandPark;
